import { Box } from "@material-ui/core";
import React from "react";
import { OverviewBlock, Overview } from "./OverviewBlock";

interface Props {
  properties: Array<Overview>;
  setProperties: (properties: Array<Overview>) => void;
  overviewError: boolean
}

export const OverviewContainer = ({
  properties,
  setProperties,
  overviewError
}: Props) => {
  const addProperty = () => {
    const arr = [...properties];
    arr.push({
      title: "",
      value: "",
      icon: "",
    });
    setProperties(arr);
  };

  const deletePropertyRow = (rowIndex: number) => {
    const arr = [...properties];
    const newArray = [...arr.slice(0, rowIndex), ...arr.slice(rowIndex + 1)];
    setProperties(newArray);
  };

  const handleChangeProperty = (
    rowIndex: number,
    fieldName: string,
    value: string | boolean
  ) => {
    setProperties([
      ...properties.slice(0, rowIndex),
      { ...properties[rowIndex], [fieldName]: value },
      ...properties.slice(rowIndex + 1),
    ]);
  };

  return (
    <>
      <OverviewBlock
        properties={properties}
        handleChangeProperty={handleChangeProperty}
        handleDeleteProperty={deletePropertyRow}
        handleAddProperty={addProperty}
      />
      <Box marginLeft="10%">
        {overviewError && properties.length < 2 && <div className="common-error">At least two value must be filled</div>}
        {overviewError && properties.length > 10 && <div className="common-error">You cannot add more than 10 properties</div>}
      </Box>
    </>
  );
};
